import { environment } from '@environments/environment';

export const baseUri = `${environment.apiUri}/escalations`;
export const byIdUri = `${baseUri}/:id`;
export const escalationCategoriesUri = `${baseUri}/categories`;
export const actionUri = `${byIdUri}/actions`;
